<template>
    <ValidationProvider
        :name="name"
        :rules="rules"
        v-slot="{ errors }"
        :class="classWrapper"
        tag="div"
        class="c-container"
    >
        <div class="c-wrapper position-relative">
            <div class="upload-area" @click="!viewMode && handleTriggerUpload()">
                <input
                    ref="inputFile"
                    type="file"
                    accept="image/*"
                    hidden
                    @change="onUpload"
                />
                <input :value="value" :id="name" hidden />
                <a v-if="value && viewMode" href="javascript:;" class="images-viewer" v-viewer="{movable: false}">
                    <img v-if="value" :src="value" alt="" />
                </a>
                <img v-else-if="value" :src="value" alt="" />
            </div>

            <a class="remove-image-btn" v-if="removable && value" @click="remove" href="javascript:;" style="font-size: 19px;">
                <i class="fas fa-trash-alt text-secondary"></i>
            </a>
        </div>
        <span class="custom-error">{{ errors[0] }}</span>
    </ValidationProvider>
</template>

<script>
import 'viewerjs/dist/viewer.css'
import Viewer from 'v-viewer'
import Vue from "vue";

Vue.use(Viewer);
export default {
    name: 'UploadImage',
    props: {
        value: {
            type: String,
            required: true,
        },
        name: {
            type: String,
            required: true,
        },
        rules: {
            type: [String, Array, Object],
        },
        classWrapper: {
            type: String,
        },
        viewMode: {
            type: Boolean,
            default: false,
        },
        removable: {
            type: Boolean,
            default: false,
        },
    },
    methods: {
        show () {
            const viewer = this.$el.querySelector('.images-viewer').$viewer
            viewer.show()
        },
        remove() {
            this.$emit('input', '');
        },
        handleTriggerUpload() {
            this.$refs.inputFile.click();
        },
        async onUpload(event) {
            const file = event.target.files[0];
            const reader = new FileReader();

            reader.onload = (e) => {
                const img = new Image();
                img.src = e.target.result;

                img.onload = async () => {
                    const canvas = document.createElement('canvas');
                    const ctx = canvas.getContext('2d');

                    // Resize the image to a desired width and height
                    const maxWidth = 750; // Set your desired maximum width
                    let newWidth = img.width;
                    let newHeight = img.height;

                    if (img.width > maxWidth) {
                        const aspectRatio = img.width / img.height;
                        newWidth = maxWidth;
                        newHeight = maxWidth / aspectRatio;
                    }

                    canvas.width = newWidth;
                    canvas.height = newHeight;

                    ctx.drawImage(img, 0, 0, newWidth, newHeight);

                    // Convert the canvas content to a data URL
                    const resizedDataURL = canvas.toDataURL('image/jpeg');

                    // You can now use 'resizedDataURL' to upload or display the resized image
                    this.$emit('input', resizedDataURL);
                };
            };
            reader.readAsDataURL(file);
        },
    },
};
</script>

<style lang="scss" scoped>
.c-container {
    &:not(:last-child) {
        margin-bottom: 24px;
    }
}
.c-wrapper {
    cursor: pointer;
    position: relative;
    min-height: 200px;
    background-color: rgb(234, 240, 243);

    width: 100%;
    border-radius: 20px;

    .upload-area {
        min-height: 200px;
    }

    img {
        object-fit: cover;
        max-width: 100%;
        width: 100%;
        border-radius: 20px;
    }
}
.remove-image-btn {
    position: absolute;
    top: 40%;
    right: -30px;
    width: 30px;
    height: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
}
.custom-error {
    color: var(--danger);
    font-size: 12px;
}
</style>
